import { watch, ref, Ref, toRefs, nextTick } from 'vue'
import { IComboBoxStandardProps } from './combobox.type'

const useComboBoxStandard = (props: IComboBoxStandardProps) => {
  const { items } = toRefs(props)
  const storeItems: Ref<any[]> = ref([])

  watch(items, async (newVal: any[]) => {
    storeItems.value = []
    await nextTick()

    storeItems.value = newVal
  }, { immediate: true })

  return {
    storeItems
  }
}

export default useComboBoxStandard
